import React, { useEffect, useState } from "react";
import { FiHome } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router";
import axios from "axios";
import $ from "jquery";

import "../css/librarySearch.css";

export default function SearchLibrary() {

    let { libraryid } = useParams();

    const [ libraryName, setLibName ] = useState("");
    const [ creatorName, setCreatorName ] = useState("");

    useEffect(() => {
        axios.get(`https://cloudify-backend.herokuapp.com/libraries/details/${libraryid}`)
        .then(lib => {
            var data = lib.data.library;

            console.log(data);

            setLibName(data.libraryName);

            if(data.books) {
                data.books.forEach(book => {

                    axios.get(`https://www.googleapis.com/books/v1/volumes/${book.bookId}`)
                    .then(resp => {
                        var volumeInfo = resp.data.volumeInfo;
                        $("#booksHolder").append(` <div id="generatedBookDisplayer"> <img src="${volumeInfo.imageLinks.thumbnail}" /> </div> `)
                    })
                })
            }

            setLibName(data.libraryName);

            axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${data.ownerId}`)
            .then(usr => {
                var usrData = usr.data.userInfo;

                setCreatorName(usrData.username);

                document.getElementById("libOwnerPic").src = usrData.profilePicture;

                document.getElementById("ownerProfileUrl").href = `/community/users/${usrData.username}`;
            })
        });
    }, [])

    return (
        <div className="centered">
            <div id="librarySarchHandler">
                <Link to="/" > <FiHome style={{"color":"white", "fontSize":"32px"}} /> </Link>
                
                <div className="centered">
                   <div id="creatorInfoDisplayer">
                        <h2 id="ownerNameDisplayer">Criada por</h2>
                        <a id="ownerProfileUrl">
                            <h2 id="ownerNameDisplayer" style={{"marginLeft":"5px"}} >@{creatorName}</h2>
                        </a>
                   </div>
                </div>
                
                <div className="centered">
                    <div id="libraryOwnerPicDisplayer">
                        <img id="libOwnerPic"/>
                    </div>
                </div>

                <div className="centered">
                    <div id="libraryDisplayingTitle">
                        <h1>{libraryName}</h1>
                    </div>
                </div>

                <div className="centered">
                    <div id="booksHolder" />
                </div>
            </div>
        </div>
    )
}